import clsx from 'clsx'
import { FC, ReactNode } from 'react'
import React from 'react'

import s from './styles.module.scss'

import Capacity from '../capacity/capacity'
import { Rating } from '../rating/Rating'
import NextImage from '../../atoms/containers/Image/next-image'
import { TagAutonomousBooking } from '../../atoms/fields/Tag/tag-autonomous-booking/TagAutonomousBooking'
import IconSvg from '../../atoms/icons/icon-svg'
import { HousesInformationsFieldsFragment } from '../../../lib/graphql'

interface ContentProps {
  addButton?: ReactNode
  closeButton?: ReactNode
  house: HousesInformationsFieldsFragment
}

export const DefaultContent: FC<ContentProps> = ({
  house,
  addButton,
  closeButton,
}) => {
  const titleWords = house.title.split(' ')
  const lastWord = titleWords.pop()
  const restOfTitle = titleWords.join(' ')

  return (
    <>
      <div className={s.cardLocation}>
        <p>
          {house?.address?.department &&
            house?.address?.region &&
            `${house?.address?.department}, ${house?.address?.region}`}
        </p>
      </div>
      <p className={s.cardTitle}>
        {restOfTitle}&nbsp;
        <span style={{ whiteSpace: 'nowrap' }}>{lastWord}&nbsp;</span>
      </p>
      <Rating
        rating={house.googleRating?.rating}
        userRatingsTotal={house.googleRating?.userRatingsTotal}
      />
      <Capacity
        beds={house.numberOfBeds ?? 0}
        bedrooms={house.numberOfBedrooms ?? 0}
        capacity={house.capacity ?? 0}
        className={s.cardCapacity}
        dailyMaxCapacity={house.options.studyDay.options?.capacity.max}
        numberOfWorkspaces={house.numberOfWorkspaces}
        corporateEveningEventMaxCapacity={
          house.options?.corporateEvening.options?.capacity.max
        }
      />

      <div className={s.cardImageContainer}>
        <NextImage
          src={house.coverPicture.uri}
          alt=''
          className={s.cardImage}
          style={{ paddingTop: 0 }}
          sizes='(max-width: 768px) 85vw, 21vw'
        />
        {house.isAutonomousBookingAvailable && (
          <TagAutonomousBooking className={s.autonomousBadge} />
        )}
      </div>

      {addButton}
      {closeButton}
    </>
  )
}

export const ExecutiveContent: FC<ContentProps> = ({
  house,
  addButton,
  closeButton,
}) => {
  const titleWords = house.title.split(' ')
  const lastWord = titleWords.pop()
  const restOfTitle = titleWords.join(' ')

  return (
    <>
      <div className={s.cardImageExecutive}>
        <NextImage
          src={house.coverPicture.uri}
          alt=''
          className={s.cardImage}
          style={{ paddingTop: 0 }}
          sizes='(max-width: 768px) 85vw, 21vw'
        />
        {house.isAutonomousBookingAvailable && <TagAutonomousBooking />}
      </div>

      {addButton}

      <Capacity
        beds={house.numberOfBeds ?? 0}
        bedrooms={house.numberOfBedrooms ?? 0}
        capacity={house.capacity ?? 0}
        className={clsx(s.cardCapacity, s.isExecutive)}
        dailyMaxCapacity={house.options.studyDay.options?.capacity.max}
        corporateEveningEventMaxCapacity={
          house.options?.corporateEvening.options?.capacity.max
        }
        numberOfWorkspaces={house.numberOfWorkspaces}
      />
      <p className={clsx(s.cardTitle, s.isExecutive)}>
        {restOfTitle}&nbsp;
        <span style={{ whiteSpace: 'nowrap' }}>{lastWord}&nbsp;</span>
      </p>
      <div className={clsx(s.cardLocation, s.isExecutive)}>
        <p>
          {house?.address?.department &&
            house?.address?.region &&
            `${house?.address?.department}, ${house?.address?.region}`}
        </p>
      </div>

      {closeButton}

      <div className={s.cardBadgeExecutive}>
        <IconSvg.RoomService color='currentColor' />
        <span>Executive</span>
      </div>
    </>
  )
}
